import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ListComponent, ProductPricing } from "reg-hub-common";
import { ServicePricingRepositoryService } from '../../services/service-pricing/service-pricing.service';

@Component({
    selector: 'app-service-pricing',
    templateUrl: './service-pricing.component.html',
    styleUrls: ['./service-pricing.component.css'],
    animations: [
        trigger('detailExpand', [
            state('collapsed,void', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ServicePricingComponent extends ListComponent<ProductPricing> {

  protected expandedPrice: ProductPricing | null = null;

  displayedColumns: string[] = [
    'productCode',
    'description',
    'total'
  ];

  constructor(
    repo: ServicePricingRepositoryService,) {
    super(repo);
  }

  ngOnInit(): void {

  }
}
